import ScalarIconGearSix_vue_vue_type_script_setup_true_lang_default from "./ScalarIconGearSix.vue.script.js";
//#region src/components/ScalarIconGearSix.vue
var ScalarIconGearSix_default = ScalarIconGearSix_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconGearSix_default as default };

//# sourceMappingURL=ScalarIconGearSix.js.map